import Gtm from '@grebban/gtm';

export default () => {
    Gtm.addDataLayerEvent('email_signup', {
        location: location.pathname,
        event_category: 'checkout',
        event_label: 'checked',
        event_action: "Subscribe To Newsletter"
    });
}